import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);

const KEY = "dripdash_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (product, variant, qty = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.product_id === product.product_id && i.variant_sku === variant.sku);
      if (idx >= 0) {
        const clone = [...prev]; clone[idx] = { ...clone[idx], qty: clone[idx].qty + qty };
        return clone;
      }
      return [...prev, {
        product_id: product.product_id, product_name: product.name,
        slug: product.slug, image: product.images?.[0] || "",
        variant_sku: variant.sku, variant_label: variant.label,
        unit_price: variant.price, qty,
      }];
    });
    setOpen(true);
  };

  const update = (sku, pid, qty) => {
    if (qty <= 0) return remove(sku, pid);
    setItems((prev) => prev.map((i) =>
      i.variant_sku === sku && i.product_id === pid ? { ...i, qty } : i));
  };
  const remove = (sku, pid) =>
    setItems((prev) => prev.filter((i) => !(i.variant_sku === sku && i.product_id === pid)));
  const clear = () => setItems([]);
  const subtotal = items.reduce((s, i) => s + i.unit_price * i.qty, 0);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartCtx.Provider value={{ items, add, update, remove, clear, subtotal, count, open, setOpen }}>
      {children}
    </CartCtx.Provider>
  );
}
